/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type PatientAuthorizationUsageScope = typeof PatientAuthorizationUsageScope[keyof typeof PatientAuthorizationUsageScope];


export const PatientAuthorizationUsageScope = {
  ClaimServiceLine: 'ClaimServiceLine',
  ClaimLevelBox23: 'ClaimLevelBox23',
} as const;
